export const alertConstants = {
  SUCCESS: 'ALERT_SUCCESS',
  FAILURE: 'ALERT_FAILURE',
  CLEAR: 'ALERT_CLEAR',
  RESET_STORE: 'RESET_STORE',
  MANIPULATE_SIDEBAR: 'MANIPULATE_SIDEBAR'
}